import axios from "axios";
import * as types from "../stores/constants";
import useModuleStore from "../stores";
// export const set = property => ( payload) =>
// {
//     const store = useModuleStore();
//     store[property] = payload
// }

// export const toggle = property => state => (state[property] = !state[property])

export const cloneObject = function (src) {
    return JSON.parse(JSON.stringify(src));
};
export const clearSnapshotForms = function (form_name) {
    if(!!form_name) {
        $(`#${form_name}`).trigger('reset');
        // clear checkboxes
        objCommon.general_radios_and_checkboxes('.snapshot');
        $(':checkbox').prop('checked', false);
        objCommon.general_radios_and_checkboxes('.snapshot');
    }
};

export const getAxiosInstance = function () {
    const instance = axios.create({
        headers: {'X-Requested-With': 'XMLHttpRequest'},
    })

    const vm = this;
    instance.interceptors.response.use(function(response) {
        const store = useModuleStore();

        if (response.headers['x-csrf-token']) {
            let token = response.headers['x-csrf-token'].split(';');
            objCommon.setNewCSRF(token[0], token[1], token[2]);
        }
        const data = response.data;
        if (data.result === 'ERROR') {
            store.commit('SHOW_ERROR_ALERT', 'API Error - ' + data.error.explanation);
            store.commit(types.TOGGLE_LOADING, false, {root: true});
        }
        return response;
    }, function (error) {
        const store = useModuleStore();
        if (!!error && !!(error.response) && !!(error.response.headers) && error.response.headers['x-csrf-token']) {
            let token = error.response.headers['x-csrf-token'].split(';');
            objCommon.setNewCSRF(token[0], token[1], token[2]);
        }

        if (error.response.status === 401) {
            store.commit('SHOW_ERROR_ALERT', '401 Unauthorised: Session Expired');

            if (!!store?.user && store.user?.is_public_user === '1') {
                let alliance = store.state.alliance
                window.location.href = '/applynow/' + alliance.alliance_code;
            } else {
                window.location.href = '/login';
            }
        } else if (error.response.status === 403) {
            // store.commit('SHOW_ERROR_ALERT', `403 Forbidden: Permission denied on endpoint ${error.response.request.responseURL}`);
            store.commit('SHOW_ERROR_ALERT', `Oops... an error has occurred. Please use a single browser tab for all operations, refresh the page and try again.`);
        } else {
            store.commit('SHOW_ERROR_ALERT', `Unexpected error`);
        }
        store.commit(types.TOGGLE_LOADING, false, {root: true});
        return Promise.reject(error);
    });
    return instance;
}();


export const getTabConfig = (page_config, tab_config, entity, prefix = '') =>
{
    let managed_page_config = [];

    const allowNonConfigTabs = function (page_config, entity) {
        const non_config_tabs = [
            'ValidationErrors',
            'Audits'
        ];

        if (non_config_tabs.includes(page_config) ) {
            if (page_config == 'ValidationErrors' &&  entity.has_validation_errors != '1') {
                return false;
            }
            return true
        }
        return false;
    };

    tab_config.forEach((obj) => {
        obj.url_router = (!!prefix ? prefix : '') + obj.url;
        const allow_non_config_tabs = allowNonConfigTabs(obj.page_config, entity);
        if(allow_non_config_tabs || !!page_config[obj.page_config]) {
            managed_page_config.push(obj);
        }
    });

    return managed_page_config;
};